// import React, { useState, useEffect } from 'react';
// import { ChevronRight, Phone, Mail, MapPin, Clock, Menu, X, ChevronLeft, Award, Users, Heart, Shield, Stethoscope, Wind, Activity, Microscope } from 'lucide-react';
// import Header from './header';
// import HeroSlider from './HeroSlider';
// import AboutSection from './about';
// import Footer from './footer';
// import DoctorsSection from './doctorsSection';
// import WhyChooseUsSection from './whychooseus';
// import anudeep from './Images/anudeep.jpeg';



// const VayuLungCareWebsite = () => {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [scrolled, setScrolled] = useState(false);

//   // Hero slider images
//   const heroSlides = [
//     {
//       image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1920&q=80",
//       title: "Excellence in Respiratory Care",
//       subtitle: "Advanced pulmonology treatments with compassionate care"
//     },
//     {
//       image: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=1920&q=80",
//       title: "Multi-Speciality Healthcare",
//       subtitle: "Comprehensive medical services under one roof"
//     },
//     {
//       image: "https://images.unsplash.com/photo-1666214280557-f1b5022eb634?w=1920&q=80",
//       title: "State-of-the-Art Facilities",
//       subtitle: "Modern equipment for accurate diagnosis and treatment"
//     }
//   ];

//   // Doctors data
  

//   // Services data
//   const services = [
//     {
//       icon: <Wind className="w-8 h-8" />,
//       title: "Pulmonology",
//       description: "Comprehensive respiratory care including asthma, COPD, and lung diseases",
//       treatments: ["Spirometry", "Bronchoscopy", "Sleep Studies", "Nebulization"]
//     },
//     {
//       icon: <Heart className="w-8 h-8" />,
//       title: "Cardiology",
//       description: "Advanced cardiac care and heart disease management services",
//       treatments: ["ECG", "Echo", "Stress Test", "Holter Monitoring"]
//     },
//     {
//       icon: <Activity className="w-8 h-8" />,
//       title: "Critical Care",
//       description: "24/7 ICU facilities with advanced life support systems",
//       treatments: ["Ventilator Support", "Hemodynamic Monitoring", "Dialysis", "Emergency Care"]
//     },
//     {
//       icon: <Stethoscope className="w-8 h-8" />,
//       title: "General Medicine",
//       description: "Primary healthcare services for all age groups",
//       treatments: ["Health Check-ups", "Chronic Disease Management", "Preventive Care", "Vaccinations"]
//     },
//     {
//       icon: <Microscope className="w-8 h-8" />,
//       title: "Diagnostics",
//       description: "State-of-the-art diagnostic facilities for accurate results",
//       treatments: ["X-Ray", "CT Scan", "Ultrasound", "Laboratory Tests"]
//     },
//     {
//       icon: <Shield className="w-8 h-8" />,
//       title: "Preventive Care",
//       description: "Comprehensive health screening and wellness programs",
//       treatments: ["Annual Check-ups", "Health Counseling", "Nutrition Guidance", "Lifestyle Management"]
//     }
//   ];

//   // Auto-slide effect
//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
//     }, 5000);
//     return () => clearInterval(timer);
//   }, []);

//   // Scroll effect for header
//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const nextSlide = () => {
//     setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
//   };

//   const prevSlide = () => {
//     setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
//   };

//   return (
//     <div className="vayu-website">
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         :root {
//           --primary-orange: #E86A33;
//           --primary-blue: #1B4965;
//           --accent-blue: #2C5F7C;
//           --light-blue: #62B6CB;
//           --orange-light: #FF9B6E;
//           --text-dark: #1a1a1a;
//           --text-light: #666;
//           --bg-light: #F8FAFB;
//         }

//         body {
//           font-family: 'Inter', sans-serif;
//           overflow-x: hidden;
//           color: var(--text-dark);
//         }

//         .vayu-website {
//           width: 100%;
//           min-height: 100vh;
//         }

//         /* ========== HEADER ========== */
//         .header {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           z-index: 1000;
//           transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//           background: transparent;
//         }

//         .header.scrolled {
//           background: rgba(255, 255, 255, 0.98);
//           backdrop-filter: blur(20px);
//           box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);
//         }

//         .header-top {
//           background: linear-gradient(135deg, var(--primary-blue), var(--accent-blue));
//           padding: 0.8rem 0;
//           color: white;
//           font-size: 0.85rem;
//         }

//         .header.scrolled .header-top {
//           display: none;
//         }

//         .header-top-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 0 2rem;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           flex-wrap: wrap;
//           gap: 1rem;
//         }

//         .header-contact {
//           display: flex;
//           gap: 2rem;
//           align-items: center;
//         }

//         .contact-item {
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .header-main {
//           padding: 1.2rem 0;
//           transition: padding 0.4s ease;
//         }

//         .header.scrolled .header-main {
//           padding: 0.8rem 0;
//         }

//         .header-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 0 2rem;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .logo {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           text-decoration: none;
//           transition: transform 0.3s ease;
//         }

//         .logo:hover {
//           transform: translateY(-2px);
//         }

//         .logo-icon {
//           width: 55px;
//           height: 55px;
//           background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           font-weight: 800;
//           font-size: 1.5rem;
//           transition: all 0.3s ease;
//         }

//         .header.scrolled .logo-icon {
//           width: 45px;
//           height: 45px;
//           font-size: 1.2rem;
//         }

//         .logo-text h1 {
//           font-family: 'Playfair Display', serif;
//           font-size: 1.8rem;
//           font-weight: 700;
//           color: var(--primary-blue);
//           line-height: 1.2;
//           transition: font-size 0.3s ease;
//         }

//         .header.scrolled .logo-text h1 {
//           font-size: 1.5rem;
//         }

//         .logo-text p {
//           font-size: 0.75rem;
//           color: var(--text-light);
//           font-weight: 500;
//           letter-spacing: 0.5px;
//         }

//         .nav {
//           display: flex;
//           align-items: center;
//           gap: 3rem;
//         }

//         .nav-links {
//           display: flex;
//           gap: 2.5rem;
//           list-style: none;
//         }

//         .nav-link {
//           color: var(--primary-blue);
//           text-decoration: none;
//           font-weight: 600;
//           font-size: 0.95rem;
//           position: relative;
//           transition: color 0.3s ease;
//           letter-spacing: 0.3px;
//         }

//         .header.scrolled .nav-link {
//           color: var(--text-dark);
//         }

//         .nav-link::after {
//           content: '';
//           position: absolute;
//           bottom: -5px;
//           left: 0;
//           width: 0;
//           height: 2px;
//           background: var(--primary-orange);
//           transition: width 0.3s ease;
//         }

//         .nav-link:hover {
//           color: var(--primary-orange);
//         }

//         .nav-link:hover::after {
//           width: 100%;
//         }

//         .cta-button {
//           padding: 0.8rem 2rem;
//           background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-weight: 600;
//           font-size: 0.95rem;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//           transition: all 0.3s ease;
//           box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
//         }

//         .cta-button:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
//         }

//         .mobile-menu-btn {
//           display: none;
//           background: none;
//           border: none;
//           color: var(--primary-blue);
//           cursor: pointer;
//           padding: 0.5rem;
//         }

//         /* ========== HERO SLIDER ========== */
//         .hero-slider {
//           position: relative;
//           height: 100vh;
//           margin-top: 0;
//           overflow: hidden;
//         }

//         .slide {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           opacity: 0;
//           transition: opacity 1s ease-in-out;
//         }

//         .slide.active {
//           opacity: 1;
//         }

//         .slide-image {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .slide-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: linear-gradient(135deg, rgba(27, 73, 101, 0.85) 0%, rgba(44, 95, 124, 0.75) 50%, rgba(232, 106, 51, 0.6) 100%);
//         }

//         .slide-content {
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%);
//           text-align: center;
//           color: white;
//           width: 90%;
//           max-width: 900px;
//           z-index: 2;
//         }

//         .slide.active .slide-content {
//           animation: slideUp 1s ease forwards;
//         }

//         @keyframes slideUp {
//           from {
//             opacity: 0;
//             transform: translate(-50%, -40%);
//           }
//           to {
//             opacity: 1;
//             transform: translate(-50%, -50%);
//           }
//         }

//         .slide-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 4rem;
//           font-weight: 800;
//           margin-bottom: 1.5rem;
//           line-height: 1.2;
//           text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
//         }

//         .slide-subtitle {
//           font-size: 1.5rem;
//           font-weight: 300;
//           margin-bottom: 2.5rem;
//           opacity: 0.95;
//         }

//         .slider-controls {
//           position: absolute;
//           bottom: 4rem;
//           left: 50%;
//           transform: translateX(-50%);
//           display: flex;
//           gap: 1rem;
//           z-index: 3;
//         }

//         .slider-btn {
//           width: 50px;
//           height: 50px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.2);
//           backdrop-filter: blur(10px);
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           color: white;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: all 0.3s ease;
//         }

//         .slider-btn:hover {
//           background: var(--primary-orange);
//           border-color: var(--primary-orange);
//           transform: scale(1.1);
//         }

//         .slider-dots {
//           position: absolute;
//           bottom: 2rem;
//           left: 50%;
//           transform: translateX(-50%);
//           display: flex;
//           gap: 0.8rem;
//           z-index: 3;
//         }

//         .dot {
//           width: 12px;
//           height: 12px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.4);
//           border: 2px solid rgba(255, 255, 255, 0.6);
//           cursor: pointer;
//           transition: all 0.3s ease;
//         }

//         .dot.active {
//           background: var(--primary-orange);
//           border-color: var(--primary-orange);
//           width: 40px;
//           border-radius: 10px;
//         }

//         /* ========== ABOUT SECTION ========== */
//         .about-section {
//           padding: 8rem 2rem;
//           background: white;
//         }

//         .about-container {
//           max-width: 1300px;
//           margin: 0 auto;
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 6rem;
//           align-items: center;
//         }

//         .about-image-wrapper {
//           position: relative;
//         }

//         .about-image {
//           width: 100%;
//           height: 600px;
//           object-fit: cover;
//           border-radius: 30px;
//           box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
//         }

//         .about-image-accent {
//           position: absolute;
//           bottom: -30px;
//           right: -30px;
//           width: 200px;
//           height: 200px;
//           background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
//           border-radius: 30px;
//           z-index: -1;
//         }

//         .about-stats {
//           position: absolute;
//           bottom: 40px;
//           left: 40px;
//           background: white;
//           padding: 2rem;
//           border-radius: 20px;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
//           display: flex;
//           gap: 2rem;
//         }

//         .stat-item {
//           text-align: center;
//         }

//         .stat-number {
//           font-size: 2.5rem;
//           font-weight: 800;
//           color: var(--primary-orange);
//           font-family: 'Playfair Display', serif;
//         }

//         .stat-label {
//           font-size: 0.85rem;
//           color: var(--text-light);
//           font-weight: 600;
//         }

//         .about-content {
//           padding-right: 2rem;
//         }

//         .section-label {
//           font-size: 0.9rem;
//           font-weight: 700;
//           color: var(--primary-orange);
//           letter-spacing: 3px;
//           text-transform: uppercase;
//           margin-bottom: 1rem;
//           display: inline-block;
//         }

//         .section-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 3.5rem;
//           font-weight: 800;
//           color: var(--primary-blue);
//           margin-bottom: 1.5rem;
//           line-height: 1.2;
//         }

//         .about-text {
//           font-size: 1.1rem;
//           color: var(--text-light);
//           line-height: 1.9;
//           margin-bottom: 1.5rem;
//         }

//         .about-features {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 1.5rem;
//           margin-top: 3rem;
//         }

//         .feature-item {
//           display: flex;
//           align-items: flex-start;
//           gap: 1rem;
//         }

//         .feature-icon {
//           width: 50px;
//           height: 50px;
//           background: linear-gradient(135deg, var(--primary-blue), var(--accent-blue));
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           flex-shrink: 0;
//         }

//         .feature-text h4 {
//           font-size: 1.1rem;
//           font-weight: 700;
//           color: var(--primary-blue);
//           margin-bottom: 0.3rem;
//         }

//         .feature-text p {
//           font-size: 0.95rem;
//           color: var(--text-light);
//         }

//         /* ========== FOUNDER SECTION ========== */
//         .founder-section {
//           padding: 8rem 2rem;
//           background: linear-gradient(135deg, var(--bg-light) 0%, white 100%);
//         }

//         .founder-container {
//           max-width: 1300px;
//           margin: 0 auto;
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 6rem;
//           align-items: center;
//         }

//         .founder-image-wrapper {
//           position: relative;
//           order: 2;
//         }

//         .founder-image {
//           width: 100%;
//           height: 880px;
//           object-fit: cover;
//           border-radius: 30px;
//           box-shadow: 0 20px 60px rgba(27, 73, 101, 0.2);
//         }

//         .founder-badge {
//           position: absolute;
//           top: 30px;
//           left: -30px;
//           background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
//           color: white;
//           padding: 1.5rem 2rem;
//           border-radius: 20px;
//           box-shadow: 0 10px 40px rgba(232, 106, 51, 0.3);
//         }

//         .badge-label {
//           font-size: 0.8rem;
//           opacity: 0.9;
//           margin-bottom: 0.3rem;
//         }

//         .badge-value {
//           font-size: 2rem;
//           font-weight: 800;
//           font-family: 'Playfair Display', serif;
//         }

//         .founder-content {
//           order: 1;
//         }

//         .founder-name {
//           font-family: 'Playfair Display', serif;
//           font-size: 3rem;
//           font-weight: 800;
//           color: var(--primary-blue);
//           margin-bottom: 0.5rem;
//         }

//         .founder-title {
//           font-size: 1.3rem;
//           color: var(--primary-orange);
//           font-weight: 600;
//           margin-bottom: 2rem;
//         }

//         .founder-credentials {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 1rem;
//           margin-bottom: 2rem;
//         }

//         .credential-badge {
//           background: var(--primary-blue);
//           color: white;
//           padding: 0.6rem 1.2rem;
//           border-radius: 50px;
//           font-size: 0.9rem;
//           font-weight: 600;
//         }

//         .founder-bio {
//           font-size: 1.05rem;
//           color: var(--text-light);
//           line-height: 1.9;
//           margin-bottom: 1.5rem;
//         }

//         .founder-achievements {
//           margin-top: 3rem;
//         }

//         .achievement-item {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           padding: 1rem 0;
//           border-bottom: 1px solid #e0e0e0;
//         }

//         .achievement-item:last-child {
//           border-bottom: none;
//         }

//         .achievement-icon {
//           width: 40px;
//           height: 40px;
//           background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
//           border-radius: 10px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//         }
//           .founder-expertise {
//   margin-top: 2rem;
// }

// .expertise-grid {
//   display: grid;
//   grid-template-columns: repeat(2, 1fr);
//   gap: 0.75rem;
// }

// .expertise-item {
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   padding: 0.5rem;
//   background: rgba(59, 130, 246, 0.05);
//   border-radius: 8px;
//   transition: all 0.3s ease;
// }

// .expertise-item:hover {
//   background: rgba(59, 130, 246, 0.1);
//   transform: translateX(5px);
// }

// .expertise-bullet {
//   color: var(--primary-blue);
//   font-size: 1.5rem;
//   font-weight: bold;
// }

// .expertise-item span:last-child {
//   color: #334155;
//   font-size: 0.95rem;
// }

// @media (max-width: 768px) {
//   .expertise-grid {
//     grid-template-columns: 1fr;
//   }
// }

//         /* ========== DOCTORS SECTION ========== */
//         .doctors-section {
//           padding: 8rem 2rem;
//           background: white;
//         }

//         .section-header {
//           text-align: center;
//           max-width: 800px;
//           margin: 0 auto 5rem;
//         }

//         .doctors-grid {
//           max-width: 1300px;
//           margin: 0 auto;
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 2.5rem;
//         }

//         .doctor-card {
//           background: white;
//           border-radius: 25px;
//           overflow: hidden;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
//           transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//           cursor: pointer;
//         }

//         .doctor-card:hover {
//           transform: translateY(-15px);
//           box-shadow: 0 20px 60px rgba(27, 73, 101, 0.15);
//         }

//         .doctor-image-wrapper {
//           position: relative;
//           height: 350px;
//           overflow: hidden;
//         }

//         .doctor-image {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           transition: transform 0.6s ease;
//         }

//         .doctor-card:hover .doctor-image {
//           transform: scale(1.1);
//         }

//         .doctor-overlay {
//           position: absolute;
//           bottom: 0;
//           left: 0;
//           right: 0;
//           background: linear-gradient(to top, rgba(27, 73, 101, 0.9) 0%, transparent 100%);
//           padding: 2rem;
//           color: white;
//         }

//         .doctor-specialty {
//           font-size: 0.85rem;
//           font-weight: 600;
//           color: var(--orange-light);
//           letter-spacing: 1px;
//           text-transform: uppercase;
//         }

//         .doctor-content {
//           padding: 2rem;
//         }

//         .doctor-name {
//           font-size: 1.5rem;
//           font-weight: 700;
//           color: var(--primary-blue);
//           margin-bottom: 0.5rem;
//         }

//         .doctor-info {
//           display: flex;
//           flex-direction: column;
//           gap: 0.5rem;
//           margin: 1rem 0;
//         }

//         .info-row {
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//           font-size: 0.9rem;
//           color: var(--text-light);
//         }

//         .doctor-description {
//           font-size: 0.95rem;
//           color: var(--text-light);
//           line-height: 1.7;
//           margin-bottom: 1.5rem;
//         }

//         .read-more-btn {
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//           color: var(--primary-orange);
//           font-weight: 600;
//           font-size: 0.95rem;
//           text-decoration: none;
//           transition: all 0.3s ease;
//         }

//         .read-more-btn:hover {
//           gap: 1rem;
//         }

//         /* ========== SERVICES SECTION ========== */
//         .services-section {
//           padding: 8rem 2rem;
//           background: linear-gradient(135deg, var(--primary-blue) 0%, var(--accent-blue) 100%);
//           position: relative;
//           overflow: hidden;
//         }

//         .services-section::before {
//           content: '';
//           position: absolute;
//           top: -50%;
//           right: -20%;
//           width: 70%;
//           height: 200%;
//           background: radial-gradient(circle, rgba(232, 106, 51, 0.1) 0%, transparent 70%);
//           animation: rotate 30s linear infinite;
//         }

//         @keyframes rotate {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }

//         .services-section .section-header {
//           color: white;
//         }

//         .services-section .section-label {
//           color: var(--orange-light);
//         }

//         .services-section .section-title {
//           color: white;
//         }

//         .services-section .about-text {
//           color: rgba(255, 255, 255, 0.9);
//         }

//         .services-grid {
//           max-width: 1300px;
//           margin: 0 auto;
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
//           gap: 2.5rem;
//           position: relative;
//           z-index: 1;
//         }

//         .service-card {
//           background: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(20px);
//           border-radius: 25px;
//           padding: 3rem;
//           border: 1px solid rgba(255, 255, 255, 0.3);
//           transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//           position: relative;
//           overflow: hidden;
//         }

//         .service-card::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           height: 5px;
//           background: linear-gradient(90deg, var(--primary-orange), var(--orange-light));
//           transform: scaleX(0);
//           transform-origin: left;
//           transition: transform 0.4s ease;
//         }

//         .service-card:hover::before {
//           transform: scaleX(1);
//         }

//         .service-card:hover {
//           background: white;
//           transform: translateY(-10px);
//           box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2);
//         }

//         .service-icon {
//           width: 80px;
//           height: 80px;
//           background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
//           border-radius: 20px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           margin-bottom: 2rem;
//           transition: all 0.4s ease;
//         }

//         .service-card:hover .service-icon {
//           transform: rotate(5deg) scale(1.1);
//         }

//         .service-title {
//           font-size: 1.8rem;
//           font-weight: 700;
//           color: var(--primary-blue);
//           margin-bottom: 1rem;
//         }

//         .service-description {
//           font-size: 1rem;
//           color: var(--text-light);
//           line-height: 1.8;
//           margin-bottom: 2rem;
//         }

//         .service-treatments {
//           display: flex;
//           flex-direction: column;
//           gap: 0.8rem;
//         }

//         .treatment-item {
//           display: flex;
//           align-items: center;
//           gap: 0.8rem;
//           font-size: 0.95rem;
//           color: var(--text-dark);
//         }

//         .treatment-bullet {
//           width: 8px;
//           height: 8px;
//           background: var(--primary-orange);
//           border-radius: 50%;
//           flex-shrink: 0;
//         }

//         /* ========== RESPONSIVE ========== */
//         @media (max-width: 1024px) {
//           .nav-links {
//             display: none;
//           }

//           .mobile-menu-btn {
//             display: block;
//           }

//           .about-container,
//           .founder-container {
//             grid-template-columns: 1fr;
//             gap: 3rem;
//           }

//           .founder-image-wrapper {
//             order: 1;
//           }

//           .founder-content {
//             order: 2;
//           }

//           .doctors-grid {
//             grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//           }

//           .services-grid {
//             grid-template-columns: 1fr;
//           }
//         }

//         @media (max-width: 768px) {
//           .slide-title {
//             font-size: 2.5rem;
//           }

//           .slide-subtitle {
//             font-size: 1.1rem;
//           }

//           .section-title {
//             font-size: 2.5rem;
//           }

//           .header-top-content {
//             justify-content: center;
//           }

//           .header-contact {
//             flex-direction: column;
//             gap: 0.5rem;
//             text-align: center;
//           }

//           .about-features {
//             grid-template-columns: 1fr;
//           }

//           .about-stats {
//             position: static;
//             margin-top: 2rem;
//           }

//           .founder-badge {
//             position: static;
//             margin-bottom: 2rem;
//             display: inline-block;
//           }
//         }
//       `}</style>
// <Header/>
//  <HeroSlider/>

//       {/* HERO SLIDER */}
//       {/* <section className="hero-slider" id="home">
//         {heroSlides.map((slide, index) => (
//           <div key={index} className={`slide ${index === currentSlide ? 'active' : ''}`}>
//             <img src={slide.image} alt={slide.title} className="slide-image" />
//             <div className="slide-overlay"></div>
//             <div className="slide-content">
//               <h1 className="slide-title">{slide.title}</h1>
//               <p className="slide-subtitle">{slide.subtitle}</p>
//               <button className="cta-button">
//                 Explore Services
//                 <ChevronRight size={20} />
//               </button>
//             </div>
//           </div>
//         ))}

//         <div className="slider-controls">
//           <button className="slider-btn" onClick={prevSlide}>
//             <ChevronLeft size={24} />
//           </button>
//           <button className="slider-btn" onClick={nextSlide}>
//             <ChevronRight size={24} />
//           </button>
//         </div>

//         <div className="slider-dots">
//           {heroSlides.map((_, index) => (
//             <div
//               key={index}
//               className={`dot ${index === currentSlide ? 'active' : ''}`}
//               onClick={() => setCurrentSlide(index)}
//             />
//           ))}
//         </div>
//       </section> */}

//       {/* ABOUT SECTION */}
//       {/* <section className="about-section" id="about">
//         <div className="about-container">
//           <div className="about-image-wrapper">
//             <img
//               src="https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&q=80"
//               alt="Vayu Lung Care Clinic"
//               className="about-image"
//             />
//             <div className="about-image-accent"></div>
//             <div className="about-stats">
//               <div className="stat-item">
//                 <div className="stat-number">15+</div>
//                 <div className="stat-label">Years</div>
//               </div>
//               <div className="stat-item">
//                 <div className="stat-number">10K+</div>
//                 <div className="stat-label">Patients</div>
//               </div>
//               <div className="stat-item">
//                 <div className="stat-number">24/7</div>
//                 <div className="stat-label">Support</div>
//               </div>
//             </div>
//           </div>

//           <div className="about-content">
//             <span className="section-label">About Us</span>
//             <h2 className="section-title">Leading Healthcare Provider in Hyderabad</h2>
//             <p className="about-text">
//               VAYU Lung Care and Multi-Speciality Clinics is a premier healthcare facility dedicated to providing comprehensive medical services with a special focus on respiratory care. Our state-of-the-art facility combines advanced medical technology with compassionate care.
//             </p>
//             <p className="about-text">
//               Founded by Dr. Anudeep, our clinic has been serving the community for over 15 years, earning trust through excellence in patient care, accurate diagnostics, and effective treatments. We believe in treating patients, not just diseases.
//             </p>

//             <div className="about-features">
//               <div className="feature-item">
//                 <div className="feature-icon">
//                   <Award size={24} />
//                 </div>
//                 <div className="feature-text">
//                   <h4>Expert Team</h4>
//                   <p>Highly qualified specialists</p>
//                 </div>
//               </div>
//               <div className="feature-item">
//                 <div className="feature-icon">
//                   <Shield size={24} />
//                 </div>
//                 <div className="feature-text">
//                   <h4>Advanced Care</h4>
//                   <p>Modern equipment & facilities</p>
//                 </div>
//               </div>
//               <div className="feature-item">
//                 <div className="feature-icon">
//                   <Users size={24} />
//                 </div>
//                 <div className="feature-text">
//                   <h4>Patient-Centric</h4>
//                   <p>Personalized treatment plans</p>
//                 </div>
//               </div>
//               <div className="feature-item">
//                 <div className="feature-icon">
//                   <Heart size={24} />
//                 </div>
//                 <div className="feature-text">
//                   <h4>Compassionate</h4>
//                   <p>Care with empathy & dignity</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section> */}
//       <AboutSection/>

//       {/* FOUNDER SECTION */}
//       {/* <section className="founder-section" id="founder">
//         <div className="founder-container">
//           <div className="founder-content">
//             <span className="section-label">Meet Our Founder</span>
//             <h2 className="founder-name">Dr. Anudeep</h2>
//             <p className="founder-title">Founder & Chief Pulmonologist</p>
            
//             <div className="founder-credentials">
//               <span className="credential-badge">MBBS</span>
//               <span className="credential-badge">MD (Respiratory Medicine)</span>
//               <span className="credential-badge">DNB (Pulmonology)</span>
//               <span className="credential-badge">FCCP</span>
//             </div>

//             <p className="founder-bio">
//               Dr. Anudeep is a distinguished pulmonologist with over 10 years of clinical experience in respiratory medicine and critical care. His vision of providing accessible, high-quality healthcare led to the establishment of VAYU Lung Care and Multi-Speciality Clinics.
//             </p>
//             <p className="founder-bio">
//               A pioneer in advanced bronchoscopy and interventional pulmonology, Dr. Anudeep has successfully treated thousands of patients with complex respiratory conditions. His patient-first approach and commitment to medical excellence have made VAYU a trusted name in healthcare.
//             </p>

//             <div className="founder-achievements">
//               <h3 style={{color: 'var(--primary-blue)', marginBottom: '1.5rem', fontSize: '1.5rem'}}>Key Achievements</h3>
//               <div className="achievement-item">
//                 <div className="achievement-icon">
//                   <Award size={20} />
//                 </div>
//                 <p>Gold Medalist in Respiratory Medicine</p>
//               </div>
//               <div className="achievement-item">
//                 <div className="achievement-icon">
//                   <Users size={20} />
//                 </div>
//                 <p>Treated over 10,000+ patients successfully</p>
//               </div>
//               <div className="achievement-item">
//                 <div className="achievement-icon">
//                   <Activity size={20} />
//                 </div>
//                 <p>Specialist in Sleep Disorders & Critical Care</p>
//               </div>
//             </div>
//           </div>

//           <div className="founder-image-wrapper">
//             <div className="founder-badge">
//               <div className="badge-label">Experience</div>
//               <div className="badge-value">10+ Years</div>
//             </div>
//             <img
//               src={anudeep}
//               alt="Dr. Anudeep"
//               className="founder-image"
//             />
//           </div>
//         </div>
//       </section> */}
    

//       <section className="founder-section" id="founder">
//   <div className="founder-container">
//     <div className="founder-content">
//       <span className="section-label">Meet Our Founder</span>
//       <h2 className="founder-name">Dr. K Anudeep Reddy</h2>
//       <p className="founder-title">Clinical and Interventional Pulmonologist</p>
      
//       <div className="founder-credentials">
//         <span className="credential-badge">MBBS</span>
//         <span className="credential-badge">MD (Respiratory Medicine)</span>
//       </div>

//       <p className="founder-bio">
//         Dr. Anudeep is a distinguished pulmonologist with over 5+ years of clinical experience in respiratory medicine and critical care. His vision of providing accessible, high-quality healthcare led to the establishment of VAYU Lung Care and Multi-Speciality Clinics.
//       </p>
//       <p className="founder-bio">
//         A pioneer in advanced bronchoscopy and interventional pulmonology, Dr. Anudeep has successfully treated thousands of patients with complex respiratory conditions. His patient-first approach and commitment to medical excellence have made VAYU a trusted name in healthcare.
//       </p>

//       <div className="founder-achievements">
//         <h3 style={{color: 'var(--primary-blue)', marginBottom: '1.5rem', fontSize: '1.5rem'}}>Key Achievements</h3>
//         <div className="achievement-item">
//           <div className="achievement-icon">
//             <Users size={20} />
//           </div>
//           <p>Treated over 5000+ patients successfully</p>
//         </div>
//         <div className="achievement-item">
//           <div className="achievement-icon">
//             <Activity size={20} />
//           </div>
//           <p>Specialist in Asthma, Allergy, Interventional Pulmonology, Sleep and Snoring Disorders</p>
//         </div>
//       </div>

//       <div className="founder-expertise">
//         <h3 style={{color: 'var(--primary-blue)', marginBottom: '1.5rem', fontSize: '1.5rem', marginTop: '2rem'}}>Areas of Expertise</h3>
//         <div className="expertise-grid">
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Allergy & Asthma</span>
//           </div>
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Chronic Bronchitis</span>
//           </div>
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Emphysema</span>
//           </div>
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Pneumonia</span>
//           </div>
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Tuberculosis</span>
//           </div>
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Bronchiectasis</span>
//           </div>
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Pleural Effusion (Water in Lungs)</span>
//           </div>
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Interstitial Lung Diseases</span>
//           </div>
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Occupational Lung Diseases</span>
//           </div>
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Sleep Apnea & Snoring</span>
//           </div>
//           <div className="expertise-item">
//             <span className="expertise-bullet">•</span>
//             <span>Lung Cancer</span>
//           </div>
//         </div>
//       </div>
//     </div>

//     <div className="founder-image-wrapper" style={{minHeight: '600px'}}>
//       <div className="founder-badge">
//         <div className="badge-label">Experience</div>
//         <div className="badge-value">5+ Years</div>
//       </div>
//       <img
//         src={anudeep}
//         alt="Dr. Anudeep"
//         className="founder-image"
//       />
//     </div>
//   </div>
// </section>

//       {/* DOCTORS SECTION */}
//       {/* <section className="doctors-section" id="doctors">
//         <div className="section-header">
//           <span className="section-label">Our Medical Team</span>
//           <h2 className="section-title">Meet Our Expert Doctors</h2>
//           <p className="about-text">
//             Our team of highly qualified specialists brings years of experience and expertise in their respective fields
//           </p>
//         </div>

//         <div className="doctors-grid">
//           {doctors.map((doctor) => (
//             <div key={doctor.id} className="doctor-card">
//               <div className="doctor-image-wrapper">
//                 <img src={doctor.image} alt={doctor.name} className="doctor-image" />
//                 <div className="doctor-overlay">
//                   <div className="doctor-specialty">{doctor.specialty}</div>
//                 </div>
//               </div>
//               <div className="doctor-content">
//                 <h3 className="doctor-name">{doctor.name}</h3>
//                 <div className="doctor-info">
//                   <div className="info-row">
//                     <Award size={16} />
//                     <span>{doctor.experience} Experience</span>
//                   </div>
//                   <div className="info-row">
//                     <Activity size={16} />
//                     <span>{doctor.education}</span>
//                   </div>
//                 </div>
//                 <p className="doctor-description">{doctor.description}</p>
//                 <a href={`#doctor-${doctor.id}`} className="read-more-btn">
//                   Read More
//                   <ChevronRight size={18} />
//                 </a>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section> */}
//       <DoctorsSection/>

//       {/* SERVICES SECTION */}
//       <section className="services-section" id="services">
//         <div className="section-header">
//           <span className="section-label">What We Offer</span>
//           <h2 className="section-title">Our Medical Services</h2>
//           <p className="about-text">
//             Comprehensive healthcare services with state-of-the-art facilities and advanced medical technology
//           </p>
//         </div>

//         <div className="services-grid">
//           {services.map((service, index) => (
//             <div key={index} className="service-card">
//               <div className="service-icon">
//                 {service.icon}
//               </div>
//               <h3 className="service-title">{service.title}</h3>
//               <p className="service-description">{service.description}</p>
//               <div className="service-treatments">
//                 {service.treatments.map((treatment, idx) => (
//                   <div key={idx} className="treatment-item">
//                     <div className="treatment-bullet"></div>
//                     <span>{treatment}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>
//       <WhyChooseUsSection/>
      
//     </div>
    
//   );
// };

// export default VayuLungCareWebsite;

import React, { useState, useEffect } from 'react';
import { ChevronRight, Phone, Mail, MapPin, Clock, Menu, X, ChevronLeft, Award, Users, Heart, Shield, Stethoscope, Wind, Activity, Microscope } from 'lucide-react';
import Header from './header';
import HeroSlider from './HeroSlider';
import AboutSection from './about';
import Footer from './footer';
import DoctorsSection from './doctorsSection';
import WhyChooseUsSection from './whychooseus';
import anudeep from './Images/anudeep.jpeg';
import testimonalVideo from './Videos/Vayu.Review.mp4';

const VayuLungCareWebsite = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  // Hero slider images
  const heroSlides = [
    {
      image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1920&q=80",
      title: "Excellence in Respiratory Care",
      subtitle: "Advanced pulmonology treatments with compassionate care"
    },
    {
      image: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=1920&q=80",
      title: "Multi-Speciality Healthcare",
      subtitle: "Comprehensive medical services under one roof"
    },
    {
      image: "https://images.unsplash.com/photo-1666214280557-f1b5022eb634?w=1920&q=80",
      title: "State-of-the-Art Facilities",
      subtitle: "Modern equipment for accurate diagnosis and treatment"
    }
  ];

  // Services data
  const services = [
    {
      icon: <Wind className="w-8 h-8" />,
      title: "Pulmonology",
      description: "Comprehensive respiratory care including asthma, COPD, and lung diseases",
      treatments: ["Spirometry", "Bronchoscopy", "Sleep Studies", "Nebulization"]
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: "Cardiology",
      description: "Advanced cardiac care and heart disease management services",
      treatments: ["ECG", "Echo", "Stress Test", "Holter Monitoring"]
    },
    {
      icon: <Activity className="w-8 h-8" />,
      title: "Critical Care",
      description: "24/7 ICU facilities with advanced life support systems",
      treatments: ["Ventilator Support", "Hemodynamic Monitoring", "Dialysis", "Emergency Care"]
    },
    {
      icon: <Stethoscope className="w-8 h-8" />,
      title: "General Medicine",
      description: "Primary healthcare services for all age groups",
      treatments: ["Health Check-ups", "Chronic Disease Management", "Preventive Care", "Vaccinations"]
    },
    {
      icon: <Microscope className="w-8 h-8" />,
      title: "Diagnostics",
      description: "State-of-the-art diagnostic facilities for accurate results",
      treatments: ["X-Ray", "CT Scan", "Ultrasound", "Laboratory Tests"]
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Preventive Care",
      description: "Comprehensive health screening and wellness programs",
      treatments: ["Annual Check-ups", "Health Counseling", "Nutrition Guidance", "Lifestyle Management"]
    }
  ];

  // Auto-slide effect
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  // Scroll effect for header
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  return (
    <div className="vayu-website">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        :root {
          --primary-orange: #E86A33;
          --primary-blue: #1B4965;
          --accent-blue: #2C5F7C;
          --light-blue: #62B6CB;
          --orange-light: #FF9B6E;
          --text-dark: #1a1a1a;
          --text-light: #666;
          --bg-light: #F8FAFB;
        }

        body {
          font-family: 'Inter', sans-serif;
          overflow-x: hidden;
          color: var(--text-dark);
        }

        .vayu-website {
          width: 100%;
          min-height: 100vh;
        }

        /* ========== HEADER ========== */
        .header {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1000;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          background: transparent;
        }

        .header.scrolled {
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(20px);
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);
        }

        .header-top {
          background: linear-gradient(135deg, var(--primary-blue), var(--accent-blue));
          padding: 0.8rem 0;
          color: white;
          font-size: 0.85rem;
        }

        .header.scrolled .header-top {
          display: none;
        }

        .header-top-content {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .header-contact {
          display: flex;
          gap: 2rem;
          align-items: center;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .header-main {
          padding: 1.2rem 0;
          transition: padding 0.4s ease;
        }

        .header.scrolled .header-main {
          padding: 0.8rem 0;
        }

        .header-content {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo {
          display: flex;
          align-items: center;
          gap: 1rem;
          text-decoration: none;
          transition: transform 0.3s ease;
        }

        .logo:hover {
          transform: translateY(-2px);
        }

        .logo-icon {
          width: 55px;
          height: 55px;
          background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 800;
          font-size: 1.5rem;
          transition: all 0.3s ease;
        }

        .header.scrolled .logo-icon {
          width: 45px;
          height: 45px;
          font-size: 1.2rem;
        }

        .logo-text h1 {
          font-family: 'Playfair Display', serif;
          font-size: 1.8rem;
          font-weight: 700;
          color: var(--primary-blue);
          line-height: 1.2;
          transition: font-size 0.3s ease;
        }

        .header.scrolled .logo-text h1 {
          font-size: 1.5rem;
        }

        .logo-text p {
          font-size: 0.75rem;
          color: var(--text-light);
          font-weight: 500;
          letter-spacing: 0.5px;
        }

        .nav {
          display: flex;
          align-items: center;
          gap: 3rem;
        }

        .nav-links {
          display: flex;
          gap: 2.5rem;
          list-style: none;
        }

        .nav-link {
          color: var(--primary-blue);
          text-decoration: none;
          font-weight: 600;
          font-size: 0.95rem;
          position: relative;
          transition: color 0.3s ease;
          letter-spacing: 0.3px;
        }

        .header.scrolled .nav-link {
          color: var(--text-dark);
        }

        .nav-link::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 0;
          height: 2px;
          background: var(--primary-orange);
          transition: width 0.3s ease;
        }

        .nav-link:hover {
          color: var(--primary-orange);
        }

        .nav-link:hover::after {
          width: 100%;
        }

        .cta-button {
          padding: 0.8rem 2rem;
          background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
          color: white;
          border: none;
          border-radius: 50px;
          font-weight: 600;
          font-size: 0.95rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
        }

        .cta-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
        }

        .mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          color: var(--primary-blue);
          cursor: pointer;
          padding: 0.5rem;
        }

        /* ========== FOUNDER SECTION ========== */
        .founder-section {
          padding: 8rem 2rem;
          background: linear-gradient(135deg, var(--bg-light) 0%, white 100%);
        }

        .founder-container {
          max-width: 1300px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 6rem;
          align-items: center;
        }

        .founder-image-wrapper {
          position: relative;
          order: 2;
        }

        .founder-image {
          width: 100%;
          height: 880px;
          object-fit: cover;
          border-radius: 30px;
          box-shadow: 0 20px 60px rgba(27, 73, 101, 0.2);
        }

        .founder-badge {
          position: absolute;
          top: 30px;
          left: -30px;
          background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
          color: white;
          padding: 1.5rem 2rem;
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(232, 106, 51, 0.3);
        }

        .badge-label {
          font-size: 0.8rem;
          opacity: 0.9;
          margin-bottom: 0.3rem;
        }

        .badge-value {
          font-size: 2rem;
          font-weight: 800;
          font-family: 'Playfair Display', serif;
        }

        .founder-content {
          order: 1;
        }

        .section-label {
          font-size: 0.9rem;
          font-weight: 700;
          color: var(--primary-orange);
          letter-spacing: 3px;
          text-transform: uppercase;
          margin-bottom: 1rem;
          display: inline-block;
        }

        .founder-name {
          font-family: 'Playfair Display', serif;
          font-size: 3rem;
          font-weight: 800;
          color: var(--primary-blue);
          margin-bottom: 0.5rem;
        }

        .founder-title {
          font-size: 1.3rem;
          color: var(--primary-orange);
          font-weight: 600;
          margin-bottom: 2rem;
        }

        .founder-credentials {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .credential-badge {
          background: var(--primary-blue);
          color: white;
          padding: 0.6rem 1.2rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 600;
        }

        .founder-bio {
          font-size: 1.05rem;
          color: var(--text-light);
          line-height: 1.9;
          margin-bottom: 1.5rem;
        }

        .founder-achievements {
          margin-top: 3rem;
        }

        .achievement-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem 0;
          border-bottom: 1px solid #e0e0e0;
        }

        .achievement-item:last-child {
          border-bottom: none;
        }

        .achievement-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .founder-expertise {
          margin-top: 2rem;
        }

        .expertise-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 0.75rem;
        }

        .expertise-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem;
          background: rgba(59, 130, 246, 0.05);
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .expertise-item:hover {
          background: rgba(59, 130, 246, 0.1);
          transform: translateX(5px);
        }

        .expertise-bullet {
          color: var(--primary-blue);
          font-size: 1.5rem;
          font-weight: bold;
        }

        .expertise-item span:last-child {
          color: #334155;
          font-size: 0.95rem;
        }

        /* ========== SERVICES SECTION ========== */
        .services-section {
          padding: 8rem 2rem;
          background: linear-gradient(135deg, var(--primary-blue) 0%, var(--accent-blue) 100%);
          position: relative;
          overflow: hidden;
        }

        .services-section::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -20%;
          width: 70%;
          height: 200%;
          background: radial-gradient(circle, rgba(232, 106, 51, 0.1) 0%, transparent 70%);
          animation: rotate 30s linear infinite;
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .services-section .section-header {
          color: white;
        }

        .services-section .section-label {
          color: var(--orange-light);
        }

        .section-header {
          text-align: center;
          max-width: 800px;
          margin: 0 auto 5rem;
        }

        .section-title {
          font-family: 'Playfair Display', serif;
          font-size: 3.5rem;
          font-weight: 800;
          color: var(--primary-blue);
          margin-bottom: 1.5rem;
          line-height: 1.2;
        }

        .services-section .section-title {
          color: white;
        }

        .about-text {
          font-size: 1.1rem;
          color: var(--text-light);
          line-height: 1.9;
          margin-bottom: 1.5rem;
        }

        .services-section .about-text {
          color: rgba(255, 255, 255, 0.9);
        }

        .services-grid {
          max-width: 1300px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 2.5rem;
          position: relative;
          z-index: 1;
        }

        .service-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 25px;
          padding: 3rem;
          border: 1px solid rgba(255, 255, 255, 0.3);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }

        .service-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 5px;
          background: linear-gradient(90deg, var(--primary-orange), var(--orange-light));
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.4s ease;
        }

        .service-card:hover::before {
          transform: scaleX(1);
        }

        .service-card:hover {
          background: white;
          transform: translateY(-10px);
          box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2);
        }

        .service-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          margin-bottom: 2rem;
          transition: all 0.4s ease;
        }

        .service-card:hover .service-icon {
          transform: rotate(5deg) scale(1.1);
        }

        .service-title {
          font-size: 1.8rem;
          font-weight: 700;
          color: var(--primary-blue);
          margin-bottom: 1rem;
        }

        .service-description {
          font-size: 1rem;
          color: var(--text-light);
          line-height: 1.8;
          margin-bottom: 2rem;
        }

        .service-treatments {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
        }

        .treatment-item {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          font-size: 0.95rem;
          color: var(--text-dark);
        }

        .treatment-bullet {
          width: 8px;
          height: 8px;
          background: var(--primary-orange);
          border-radius: 50%;
          flex-shrink: 0;
        }

        /* ========== RESPONSIVE DESIGN ========== */
        
        /* Large Desktop */
        @media (max-width: 1400px) {
          .header-top-content,
          .header-content {
            padding: 0 1.5rem;
          }

          .founder-container {
            gap: 4rem;
          }
        }

        /* Desktop */
        @media (max-width: 1200px) {
          .founder-container {
            gap: 3rem;
          }

          .founder-image {
            height: 700px;
          }

          .services-grid {
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 2rem;
          }
        }

        /* Tablet Landscape */
        @media (max-width: 1024px) {
          .nav-links {
            display: none;
          }

          .mobile-menu-btn {
            display: block;
          }

          .founder-container {
            grid-template-columns: 1fr;
            gap: 3rem;
          }

          .founder-image-wrapper {
            order: 1;
          }

          .founder-content {
            order: 2;
          }

          .founder-image {
            height: 600px;
          }

          .founder-badge {
            position: static;
            display: inline-block;
            margin-bottom: 2rem;
          }

          .services-grid {
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          }

          .section-title {
            font-size: 3rem;
          }
        }

        /* Tablet Portrait */
        @media (max-width: 768px) {
          .header-top {
            padding: 0.6rem 0;
            font-size: 0.8rem;
          }

          .header-top-content {
            justify-content: center;
            padding: 0 1rem;
          }

          .header-contact {
            flex-direction: column;
            gap: 0.5rem;
            text-align: center;
            width: 100%;
          }

          .contact-item {
            justify-content: center;
            font-size: 0.8rem;
          }

          .header-content {
            padding: 0 1rem;
          }

          .logo-icon {
            width: 45px;
            height: 45px;
            font-size: 1.2rem;
          }

          .logo-text h1 {
            font-size: 1.4rem;
          }

          .logo-text p {
            font-size: 0.7rem;
          }

          .cta-button {
            padding: 0.7rem 1.5rem;
            font-size: 0.9rem;
          }

          /* Founder Section */
          .founder-section {
            padding: 4rem 1.5rem;
          }

          .founder-image {
            height: 500px;
          }

          .founder-name {
            font-size: 2.2rem;
          }

          .founder-title {
            font-size: 1.1rem;
          }

          .founder-credentials {
            gap: 0.8rem;
          }

          .credential-badge {
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
          }

          .founder-bio {
            font-size: 1rem;
          }

          .achievement-item {
            padding: 0.8rem 0;
          }

          .achievement-icon {
            width: 35px;
            height: 35px;
          }

          .expertise-grid {
            gap: 0.6rem;
          }

          .expertise-item {
            padding: 0.4rem;
          }

          .expertise-item span:last-child {
            font-size: 0.9rem;
          }

          /* Services Section */
          .services-section {
            padding: 4rem 1.5rem;
          }

          .section-title {
            font-size: 2.5rem;
          }

          .about-text {
            font-size: 1rem;
          }

          .services-grid {
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          .service-card {
            padding: 2rem;
          }

          .service-icon {
            width: 70px;
            height: 70px;
          }

          .service-title {
            font-size: 1.5rem;
          }

          .service-description {
            font-size: 0.95rem;
          }
        }

        /* Mobile Large */
        @media (max-width: 480px) {
          .header-top-content {
            padding: 0 0.8rem;
          }

          .header-contact {
            gap: 0.4rem;
          }

          .contact-item {
            font-size: 0.75rem;
          }

          .header-content {
            padding: 0 0.8rem;
          }

          .logo {
            gap: 0.6rem;
          }

          .logo-icon {
            width: 40px;
            height: 40px;
            font-size: 1rem;
            border-radius: 8px;
          }

          .logo-text h1 {
            font-size: 1.2rem;
          }

          .logo-text p {
            font-size: 0.65rem;
          }

          .cta-button {
            padding: 0.6rem 1.2rem;
            font-size: 0.85rem;
            gap: 0.3rem;
          }

          /* Founder Section */
          .founder-section {
            padding: 3rem 1rem;
          }

          .section-label {
            font-size: 0.8rem;
            letter-spacing: 2px;
          }

          .founder-name {
            font-size: 1.8rem;
            line-height: 1.3;
          }

          .founder-title {
            font-size: 1rem;
            margin-bottom: 1.5rem;
          }

          .founder-credentials {
            gap: 0.6rem;
          }

          .credential-badge {
            padding: 0.4rem 0.8rem;
            font-size: 0.8rem;
          }

          .founder-badge {
            padding: 1rem 1.5rem;
            margin-bottom: 1.5rem;
          }

          .badge-label {
            font-size: 0.7rem;
          }

          .badge-value {
            font-size: 1.5rem;
          }

          .founder-image {
            height: 400px;
            border-radius: 20px;
          }

          .founder-bio {
            font-size: 0.95rem;
            line-height: 1.7;
            margin-bottom: 1.2rem;
          }

          .founder-achievements {
            margin-top: 2rem;
          }

          .founder-achievements h3 {
            font-size: 1.3rem !important;
            margin-bottom: 1.2rem !important;
          }

          .achievement-item {
            padding: 0.7rem 0;
            gap: 0.8rem;
          }

          .achievement-icon {
            width: 32px;
            height: 32px;
          }

          .achievement-item p {
            font-size: 0.9rem;
          }

          .founder-expertise {
            margin-top: 1.5rem;
          }

          .founder-expertise h3 {
            font-size: 1.3rem !important;
            margin-top: 1.5rem !important;
            margin-bottom: 1.2rem !important;
          }

          .expertise-grid {
            grid-template-columns: 1fr;
            gap: 0.5rem;
          }

          .expertise-item {
            padding: 0.4rem 0.6rem;
          }

          .expertise-bullet {
            font-size: 1.2rem;
          }

          .expertise-item span:last-child {
            font-size: 0.85rem;
          }

          /* Services Section */
          .services-section {
            padding: 3rem 1rem;
          }

          .section-header {
            margin-bottom: 3rem;
          }

          .section-title {
            font-size: 2rem;
            margin-bottom: 1rem;
          }

          .about-text {
            font-size: 0.95rem;
            line-height: 1.7;
          }

          .services-grid {
            gap: 1.5rem;
          }

          .service-card {
            padding: 1.5rem;
            border-radius: 20px;
          }

          .service-icon {
            width: 60px;
            height: 60px;
            border-radius: 15px;
            margin-bottom: 1.5rem;
          }

          .service-title {
            font-size: 1.3rem;
            margin-bottom: 0.8rem;
          }

          .service-description {
            font-size: 0.9rem;
            line-height: 1.6;
            margin-bottom: 1.5rem;
          }

          .service-treatments {
            gap: 0.6rem;
          }

          .treatment-item {
            font-size: 0.9rem;
            gap: 0.6rem;
          }

          .treatment-bullet {
            width: 6px;
            height: 6px;
          }
        }

        /* Mobile Small */
        @media (max-width: 360px) {
          .header-top {
            font-size: 0.7rem;
          }

          .contact-item {
            font-size: 0.7rem;
          }

          .logo-icon {
            width: 35px;
            height: 35px;
            font-size: 0.9rem;
          }

          .logo-text h1 {
            font-size: 1.1rem;
          }

          .logo-text p {
            font-size: 0.6rem;
          }

          .founder-name {
            font-size: 1.6rem;
          }

          .founder-title {
            font-size: 0.95rem;
          }

          .credential-badge {
            font-size: 0.75rem;
            padding: 0.35rem 0.7rem;
          }

          .founder-image {
            height: 350px;
          }

          .founder-bio {
            font-size: 0.9rem;
          }

          .achievement-item p {
            font-size: 0.85rem;
          }

          .expertise-item span:last-child {
            font-size: 0.8rem;
          }

          .section-title {
            font-size: 1.8rem;
          }

          .service-card {
            padding: 1.2rem;
          }

          .service-icon {
            width: 55px;
            height: 55px;
          }

          .service-title {
            font-size: 1.2rem;
          }

          .service-description {
            font-size: 0.85rem;
          }

          .treatment-item {
            font-size: 0.85rem;
          }
        }
      `}</style>

      <Header/>
      <HeroSlider/>
       <AboutSection/>

      {/* FOUNDER SECTION */}
      <section className="founder-section" id="founder">
        <div className="founder-container">
          <div className="founder-content">
            <span className="section-label">Meet Our Founder</span>
            <h2 className="founder-name">Dr. K Anudeep Reddy</h2>
            <p className="founder-title">Clinical and Interventional Pulmonologist</p>
            
            <div className="founder-credentials">
              <span className="credential-badge">MBBS</span>
              <span className="credential-badge">MD (Respiratory Medicine)</span>
            </div>

            <p className="founder-bio">
              Dr. Anudeep is a distinguished pulmonologist with over 5+ years of clinical experience in respiratory medicine and critical care. His vision of providing accessible, high-quality healthcare led to the establishment of VAYU Lung Care and Multi-Speciality Clinics.
            </p>
            <p className="founder-bio">
              A pioneer in advanced bronchoscopy and interventional pulmonology, Dr. Anudeep has successfully treated thousands of patients with complex respiratory conditions. His patient-first approach and commitment to medical excellence have made VAYU a trusted name in healthcare.
            </p>

            <div className="founder-achievements">
              <h3 style={{color: 'var(--primary-blue)', marginBottom: '1.5rem', fontSize: '1.5rem'}}>Key Achievements</h3>
              <div className="achievement-item">
                <div className="achievement-icon">
                  <Users size={20} />
                </div>
                <p>Treated over 5000+ patients successfully</p>
              </div>
              <div className="achievement-item">
                <div className="achievement-icon">
                  <Activity size={20} />
                </div>
                <p>Specialist in Asthma, Allergy, Interventional Pulmonology, Sleep and Snoring Disorders</p>
              </div>
            </div>

            <div className="founder-expertise">
              <h3 style={{color: 'var(--primary-blue)', marginBottom: '1.5rem', fontSize: '1.5rem', marginTop: '2rem'}}>Areas of Expertise</h3>
              <div className="expertise-grid">
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Allergy & Asthma</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Chronic Bronchitis</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Emphysema</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Pneumonia</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Tuberculosis</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Bronchiectasis</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Pleural Effusion (Water in Lungs)</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Interstitial Lung Diseases</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Occupational Lung Diseases</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Sleep Apnea & Snoring</span>
                </div>
                <div className="expertise-item">
                  <span className="expertise-bullet">•</span>
                  <span>Lung Cancer</span>
                </div>
              </div>
            </div>
          </div>

          <div className="founder-image-wrapper" style={{minHeight: '600px'}}>
            <div className="founder-badge">
              <div className="badge-label">Experience</div>
              <div className="badge-value">5+ Years</div>
            </div>
            <img
              src={anudeep}
              alt="Dr. Anudeep"
              className="founder-image"
            />
          </div>
        </div>
      </section>

     
      <DoctorsSection/>

      {/* SERVICES SECTION */}
      <section className="services-section" id="services">
        <div className="section-header">
          <span className="section-label">What We Offer</span>
          <h2 className="section-title">Our Medical Services</h2>
          <p className="about-text">
            Comprehensive healthcare services with state-of-the-art facilities and advanced medical technology
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-treatments">
                {service.treatments.map((treatment, idx) => (
                  <div key={idx} className="treatment-item">
                    <div className="treatment-bullet"></div>
                    <span>{treatment}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <WhyChooseUsSection/>
   {/* ========== VIDEO TESTIMONIALS SECTION ========== */}
<section className="video-section" id="testimonials">
  <style>{`
    .video-section {
      padding: 8rem 2rem;
      background: linear-gradient(180deg, #F8FAFB 0%, #ffffff 100%);
      overflow: hidden;
    }

    .video-section-header {
      text-align: center;
      max-width: 700px;
      margin: 0 auto 5rem;
    }

    .video-section-header .section-label {
      color: var(--primary-orange);
    }

    .video-section-header .section-title {
      font-family: 'Playfair Display', serif;
      font-size: 3.2rem;
      font-weight: 800;
      color: var(--primary-blue);
      margin-bottom: 1.2rem;
      line-height: 1.2;
    }

    .video-section-header .section-sub {
      font-size: 1.05rem;
      color: var(--text-light);
      line-height: 1.8;
    }

    /* ---- Featured Video ---- */
    .video-featured-wrapper {
      max-width: 900px;
      margin: 0 auto 5rem;
      position: relative;
      border-radius: 28px;
      overflow: hidden;
      box-shadow: 0 30px 80px rgba(27, 73, 101, 0.18);
      background: var(--primary-blue);
      cursor: pointer;
    }

    .video-featured-wrapper video,
    .video-featured-wrapper iframe {
      width: 100%;
      display: block;
      aspect-ratio: 16/9;
      border: none;
    }

    .video-featured-overlay {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        180deg,
        rgba(27, 73, 101, 0.15) 0%,
        rgba(27, 73, 101, 0.55) 100%
      );
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 2.5rem 3rem;
      transition: opacity 0.3s ease;
    }

    .video-featured-wrapper:hover .video-featured-overlay {
      opacity: 0;
    }

    .video-play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80px;
      height: 80px;
      background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 8px 30px rgba(232, 106, 51, 0.5);
      transition: all 0.3s ease;
      cursor: pointer;
      border: none;
    }

    .video-play-btn:hover {
      transform: translate(-50%, -50%) scale(1.12);
      box-shadow: 0 12px 40px rgba(232, 106, 51, 0.6);
    }

    .video-play-btn svg {
      width: 28px;
      height: 28px;
      fill: white;
      margin-left: 4px;
    }

    .video-overlay-caption {
      color: white;
    }

    .video-overlay-caption h4 {
      font-family: 'Playfair Display', serif;
      font-size: 1.6rem;
      font-weight: 700;
      margin-bottom: 0.4rem;
    }

    .video-overlay-caption p {
      font-size: 0.95rem;
      opacity: 0.85;
    }

    /* ---- Testimonial Video Grid ---- */
    .video-grid {
      max-width: 1200px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 2.5rem;
    }

    .video-card {
      background: white;
      border-radius: 22px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(27, 73, 101, 0.09);
      border: 1px solid rgba(27, 73, 101, 0.07);
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .video-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 55px rgba(27, 73, 101, 0.16);
    }

    .video-thumb-wrapper {
      position: relative;
      aspect-ratio: 16/9;
      background: var(--primary-blue);
      overflow: hidden;
      cursor: pointer;
    }

    .video-thumb-wrapper video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .video-thumb-overlay {
      position: absolute;
      inset: 0;
      background: rgba(27, 73, 101, 0.35);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.3s ease;
    }

    .video-thumb-wrapper:hover .video-thumb-overlay {
      background: rgba(27, 73, 101, 0.5);
    }

    .mini-play-btn {
      width: 52px;
      height: 52px;
      background: linear-gradient(135deg, var(--primary-orange), var(--orange-light));
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 6px 20px rgba(232, 106, 51, 0.45);
      border: none;
      cursor: pointer;
      transition: transform 0.3s ease;
    }

    .mini-play-btn:hover {
      transform: scale(1.15);
    }

    .mini-play-btn svg {
      width: 18px;
      height: 18px;
      fill: white;
      margin-left: 3px;
    }

    .video-card-body {
      padding: 1.8rem;
    }

    .patient-meta {
      display: flex;
      align-items: center;
      gap: 1rem;
      margin-bottom: 1rem;
    }

    .patient-avatar {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: linear-gradient(135deg, var(--primary-blue), var(--light-blue));
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-weight: 700;
      font-size: 1.1rem;
      flex-shrink: 0;
    }

    .patient-info h5 {
      font-size: 1rem;
      font-weight: 700;
      color: var(--primary-blue);
      margin-bottom: 0.15rem;
    }

    .patient-info span {
      font-size: 0.82rem;
      color: var(--primary-orange);
      font-weight: 600;
    }

    .patient-quote {
      font-size: 0.93rem;
      color: var(--text-light);
      line-height: 1.75;
      font-style: italic;
    }

    .star-row {
      display: flex;
      gap: 3px;
      margin-top: 1rem;
    }

    .star-row span {
      color: #f59e0b;
      font-size: 1rem;
    }

    /* Trust Badge Strip */
    .trust-strip {
      max-width: 900px;
      margin: 5rem auto 0;
      display: flex;
      justify-content: center;
      gap: 3rem;
      flex-wrap: wrap;
    }

    .trust-item {
      text-align: center;
    }

    .trust-number {
      font-family: 'Playfair Display', serif;
      font-size: 2.6rem;
      font-weight: 800;
      color: var(--primary-blue);
      line-height: 1;
    }

    .trust-label {
      font-size: 0.88rem;
      color: var(--text-light);
      margin-top: 0.4rem;
      font-weight: 500;
    }

    /* Responsive */
    @media (max-width: 1024px) {
      .video-grid {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    @media (max-width: 768px) {
      .video-section {
        padding: 5rem 1.5rem;
      }

      .video-section-header .section-title {
        font-size: 2.4rem;
      }

      .video-featured-wrapper {
        border-radius: 20px;
      }

      .video-featured-overlay {
        padding: 1.5rem 2rem;
      }

      .video-overlay-caption h4 {
        font-size: 1.3rem;
      }

      .video-play-btn {
        width: 65px;
        height: 65px;
      }

      .video-grid {
        grid-template-columns: 1fr;
        gap: 2rem;
      }

      .trust-strip {
        gap: 2rem;
      }
    }

    @media (max-width: 480px) {
      .video-section {
        padding: 3.5rem 1rem;
      }

      .video-section-header {
        margin-bottom: 3rem;
      }

      .video-section-header .section-title {
        font-size: 2rem;
      }

      .video-featured-overlay {
        padding: 1.2rem 1.5rem;
      }

      .video-play-btn {
        width: 56px;
        height: 56px;
      }

      .video-play-btn svg {
        width: 22px;
        height: 22px;
      }

      .video-overlay-caption h4 {
        font-size: 1.1rem;
      }

      .trust-number {
        font-size: 2rem;
      }

      .trust-strip {
        gap: 1.5rem;
      }
    }
  `}</style>

  {/* Section Header */}
  <div className="video-section-header">
    <span className="section-label">Real Stories</span>
    <h2 className="section-title">What Our Patients Say</h2>
    <p className="section-sub">
      Hear directly from patients who experienced life-changing care at VAYU Lung Care & Multi-Speciality Clinics.
    </p>
  </div>

  {/* Featured Video */}
  <div className="video-featured-wrapper">
    {/* Replace src with your actual featured video file or YouTube embed */}
    <video
      src={testimonalVideo}
      poster="/images/featured-poster.jpg"
      controls
      preload="none"
    />
    <div className="video-featured-overlay">
      <button className="video-play-btn" onClick={(e) => {
        e.currentTarget.closest('.video-featured-wrapper').querySelector('video').play();
        e.currentTarget.closest('.video-featured-wrapper').querySelector('.video-featured-overlay').style.opacity = '0';
        e.currentTarget.closest('.video-featured-wrapper').querySelector('.video-featured-overlay').style.pointerEvents = 'none';
      }}>
        <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
      </button>
      <div className="video-overlay-caption">
        <h4>Mrs. Dhanamma — COPD Recovery Journey</h4>
        {/* <p>From struggling to breathe to running 5km — a remarkable recovery</p> */}
      </div>
    </div>
  </div>

  {/* Video Grid */}
  {/* <div className="video-grid">
    {[
      {
        initial: 'S',
        name: 'Sunita Rao',
        condition: 'Asthma & Allergy',
        quote: '"Dr. Anudeep changed my life completely. I used to dread every monsoon season — now I barely even need my inhaler."',
        src: '/videos/testimonial-1.mp4',
        poster: '/images/poster-1.jpg',
      },
      {
        initial: 'M',
        name: 'Mohammed Farooq',
        condition: 'Sleep Apnea',
        quote: '"I hadn\'t slept properly in years. After the sleep study and treatment here, I wake up feeling genuinely rested."',
        src: '/videos/testimonial-2.mp4',
        poster: '/images/poster-2.jpg',
      },
      {
        initial: 'P',
        name: 'Priya Sharma',
        condition: 'Tuberculosis',
        quote: '"The team\'s support throughout my TB treatment was extraordinary. I felt cared for at every single step."',
        src: '/videos/testimonial-3.mp4',
        poster: '/images/poster-3.jpg',
      },
    ].map((item, i) => (
      <div className="video-card" key={i}>
        <div className="video-thumb-wrapper" onClick={(e) => {
          const vid = e.currentTarget.querySelector('video');
          const overlay = e.currentTarget.querySelector('.video-thumb-overlay');
          vid.play();
          overlay.style.opacity = '0';
          overlay.style.pointerEvents = 'none';
        }}>
          <video
            src={item.src}
            poster={item.poster}
            preload="none"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <div className="video-thumb-overlay">
            <button className="mini-play-btn">
              <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
            </button>
          </div>
        </div>
        <div className="video-card-body">
          <div className="patient-meta">
            <div className="patient-avatar">{item.initial}</div>
            <div className="patient-info">
              <h5>{item.name}</h5>
              <span>{item.condition}</span>
            </div>
          </div>
          <p className="patient-quote">{item.quote}</p>
          <div className="star-row">
            {'★★★★★'.split('').map((s, j) => <span key={j}>{s}</span>)}
          </div>
        </div>
      </div>
    ))}
  </div> */}

  {/* Trust Strip */}
  {/* <div className="trust-strip">
    {[
      { number: '5000+', label: 'Patients Treated' },
      { number: '98%', label: 'Satisfaction Rate' },
      { number: '5+', label: 'Years of Excellence' },
      { number: '500+', label: 'Video Testimonials' },
    ].map((t, i) => (
      <div className="trust-item" key={i}>
        <div className="trust-number">{t.number}</div>
        <div className="trust-label">{t.label}</div>
      </div>
    ))}
  </div> */}
</section>
    </div>
  );
};

export default VayuLungCareWebsite;
